import {configureStore, getDefaultMiddleware} from '@reduxjs/toolkit';
import statistikSlice from './features/statistikSlice';
import jmlKehadiranSlice from './features/jmlKehadiranSlice';
import kehadiranSlice from './features/kehadiranSlice';
import kategoriSlice from './features/ketegoriSlice';
import kalenderSlice from './features/kalenderSlice';
import pengaturanSlice from './features/pengaturanSlice';
import koordinatSlice from './features/koordinatSlice';
import karyawanSlice from './features/karyawanSlice';
import apiMiddleware from './middleware/apiMiddleware';
import authorizeSlice from './features/authorizeSlice';
import kehadiranDetailSlice from './features/kehadiranDetailSlice';
import siswaSlice from "./features/siswaSlice";
import kelasSlice from "./features/kelasSlice";
import jadwalGuruSlice from "./features/jadwalGuruSlice";
import jurnalDetailSlice from "./features/jurnalDetailSlice";
import jurnalSlice from "./features/jurnalSlice";
import monitorKelasSlice from "./features/monitorKelasSlice";
import buatSoalSlice from "./features/buatSoalSlice";
import penilaianGuruSlice from "./features/penilaianGuruSlice";
import waliKelasSlice from "./features/waliKelasSlice";
import siswaAttendanceHistorySlice from "./features/siswaAttendanceHistorySlice";
import jurnalSiswaSlice from "./features/jurnalSiswaSlice";

export const store = configureStore({
    reducer: {
        statistik: statistikSlice,
        jmlKehadiran: jmlKehadiranSlice,
        kehadiran: kehadiranSlice,
        kehadiranDetail: kehadiranDetailSlice,
        jurnalDetail: jurnalDetailSlice,
        jurnal: jurnalSlice,
        kategori: kategoriSlice,
        kelas: kelasSlice,
        siswa: siswaSlice,
        monitorKelasSlice: monitorKelasSlice,
        penilaianGuruSlice: penilaianGuruSlice,
        waliKelas: waliKelasSlice,
        siswaAttendanceHistory: siswaAttendanceHistorySlice,
        jurnalSiswa: jurnalSiswaSlice,
        buatSoalSlice: buatSoalSlice,

        jadwalGuruSlice: jadwalGuruSlice,
        karyawan: karyawanSlice,
        kalender: kalenderSlice,
        pengaturan: pengaturanSlice,
        koordinat: koordinatSlice,
        authorize: authorizeSlice,
    },
    middleware: [...getDefaultMiddleware(), apiMiddleware]
});